<div class="row message-container"
     [ngClass]="{ 'error': generalError || sessionExpired || invalidID }">

    <div class="col-12 message"
         align="middle">
        <div *ngIf="confirmationSuccess">
            <span>{{ 'inSign.confirmation_part_1' | translate }}</span>
            <br/>
            <span>{{ 'inSign.confirmation_part_2' | translate }}</span>
        </div>

        <span *ngIf="alreadyCompleted">{{ 'inSign.already_completed' | translate }}</span>

        <span *ngIf="generalError">{{ 'inSign.general_error' | translate }}</span>
        <span *ngIf="sessionExpired">{{ 'inSign.session_expired' | translate }}</span>
        <span *ngIf="invalidID">{{ 'inSign.invalid_id' | translate }}</span>
    </div>

</div>

